/**
 * API 配置文件
 * 统一管理所有API地址配置
 */

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL

export const API_CONFIG = {
  BASE_URL: API_BASE_URL
}

export const getApiUrl = (endpoint) => {
  return `${API_BASE_URL}/api${endpoint}`
}

export const getBaseUrl = () => API_BASE_URL
